import React, { useRef, useEffect, useState } from 'react';

const WhyChooseTheAdox = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    }
                });
            },
            { threshold: 0.1 }
        );

        const sectionElement = sectionRef.current;
        if (sectionElement) {
            observer.observe(sectionElement);
        }

        return () => {
            if (sectionElement) {
                observer.unobserve(sectionElement);
            }
        };
    }, []);

    return (
        <div 
            ref={sectionRef}
            className={`text-center transition-all duration-1000 bg-transparent ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
            style={{ backgroundColor: 'transparent' }}
        >
            {/* Responsive heading - scales from mobile to desktop */}
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold leading-tight tracking-[0.04em] sm:tracking-[0.06em] lg:tracking-[0.08em] mb-6 sm:mb-8 lg:mb-12 px-4 sm:px-6">
                <span className="text-[#E68A40]">WHY CHOOSE The</span><span className="text-white">Adox.com</span>
            </h2>
            
            {/* Responsive paragraph - scales text size and line height */}
            <div className="px-4 sm:px-6 lg:px-8">
                <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-[24px] text-white/90 max-w-[1300px] mx-auto leading-relaxed sm:leading-loose lg:leading-[2.25rem] text-center tracking-[0.02em] sm:tracking-[0.03em] lg:tracking-[0.04em]">
                    We are more than just a service; we are your strategic partner. Our approach is built on trust, expertise, 
                    and a steadfast commitment to your success. By choosing <span className="text-[#E68A40] font-bold">The</span><span className="text-white font-bold">Adox.com</span>, you gain a competitive advantage, 
                    leveraging specialised expertise without the overhead of a full-time employee. Our services are cost-effective,
                    flexible, and scalable, adapting seamlessly to your needs.
                </p>
            </div>
        </div>
    );
};

export default WhyChooseTheAdox;